module.exports = __webpack_public_path__ + "static/media/intersport.df29c840.jpg";